import React from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';
import { ButtonGroup, Button, Row, Col } from 'react-bootstrap';
import { isEmpty } from 'lodash';

import { Bert } from 'meteor/themeteorchef:bert';
import {
  projectSoftDelete,
  projectToggleShared
} from '../../../api/Projects/project-methods-client';
import * as projectOps from '../../../api/Projects/project-operations';
import Projects from '../../../api/Projects/Projects';
import { VIDEO_TYPES } from '../../../api/Videos/Videos';

import CopyURLIcon from '../../atoms/CopyURLIcon';
import PageHeader from '../../atoms/PageHeader';
import ShareIcon from '../../atoms/ShareIcon';
import Loading from '../../components/Loading';
import ProjectItemsListContainer from '../../containers/ProjectItemsListContainer';
import TableListContainer from '../../containers/TableListContainer';
import NotFound from '../NotFound';

import ButtonImport from '../../atoms/ButtonImport';

import { readUploadedFileAsText } from '../../../modules/export-import-files';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';

import { importAnnotations } from '../../../api/Annotations/annotation-methods-client';

import ModalImportAnnotations from './ModalImportAnnotations';

const ViewVideoProject = ({ project, loading, match, history, ...rest }) => {
  const [openModalImport, setOpenModalImport] = React.useState(false);
  const [datasForImport, setDatasForImport] = React.useState({});
  if (loading) {
    return <Loading />;
  }
  if (projectOps.isDeleted(project)) {
    return <NotFound />;
  }
  const { isPremium } = rest;
  const handleImportAll = async (file, projectProp) => {
    const fileContents = await readUploadedFileAsText(file);
    const parsedText = JSON.parse(fileContents);
    if (!isEmpty(parsedText)) {
      const { video } = parsedText;
      const { annotations } = parsedText;
      delete video._id;
      delete video.owner;
      video.project = projectOps.getId(projectProp);
      try {
        const newVideoId = await methodPromise('videos.insert', video);
        if (!isEmpty(annotations) && !isEmpty(newVideoId)) {
          await importAnnotations({
            variableWithObjects: parsedText,
            videoId: newVideoId,
            spatialSync: false,
            syncTimeGPS: false
          });
          Bert.alert('Video and annotations created success', 'success');
        }
        if (isEmpty(annotations) && !isEmpty(newVideoId)) {
          Bert.alert('Video created success', 'success');
        }
      } catch (error) {
        handleErrorInClient(error);
        Bert.alert('Video or annotations created has error', 'danger');
      }
    }
  };

  const handleImportAnnotations = async (file, projectProp) => {
    const projectId = projectOps.getId(projectProp);
    const videos = await methodPromise('videos.videosFromProject', projectId);
    const fileContents = await readUploadedFileAsText(file);
    const parsedText = JSON.parse(fileContents);
    const { annotations = [] } = parsedText;
    if (!isEmpty(videos) && !isEmpty(annotations)) {
      setDatasForImport({
        videos,
        annotations
      });
      setOpenModalImport(true);
    }
  };
  return (
    <>
      <PageHeader>
        <h4 className="mr-3">{projectOps.getName(project)}</h4>
        <small className="text-muted mr-auto">{projectOps.getDescription(project)}</small>
        <ShareIcon
          shared={projectOps.isShared(project)}
          shareUrl={`shared/projects/${projectOps.getId(project)}`}
        />
        <CopyURLIcon
          shared={projectOps.isShared(project)}
          shareUrl={`shared/projects/${projectOps.getId(project)}`}
        />
        <ButtonGroup size="sm">
          <Button variant="outline-secondary" onClick={() => projectToggleShared(project)}>
            {projectOps.isShared(project) ? 'Unshare' : 'Share'}
          </Button>

          <ButtonImport
            hasImportButton
            isPremium={isPremium}
            itemName="video"
            idImport="import-video"
            smSize
            variant="outline-secondary"
            handleImport={selectedFile => handleImportAll(selectedFile, project)}
          />
          <ButtonImport
            hasImportButton
            isPremium={isPremium}
            itemName="annotations"
            smSize
            idImport="import-annotations"
            variant="outline-secondary"
            handleImport={selectedFile => handleImportAnnotations(selectedFile, project)}
          />

          <ModalImportAnnotations
            openModal={openModalImport}
            setOpenModal={setOpenModalImport}
            datasForImport={datasForImport}
            {...rest}
          />

          <Button variant="outline-info" onClick={() => history.push(`${match.url}/edit`)}>
            Edit
          </Button>
          <Button
            onClick={() => projectSoftDelete(projectOps.getId(project), history)}
            variant="outline-danger"
          >
            Delete
          </Button>
        </ButtonGroup>
      </PageHeader>
      <Row>
        <Col xs={12}>
          <TableListContainer
            Page={props => (
              <ProjectItemsListContainer
                project={project}
                hasMap
                history={history}
                match={match}
                types={VIDEO_TYPES.properties}
                {...props}
                {...rest}
              />
            )}
          />
        </Col>
      </Row>
    </>
  );
};

ViewVideoProject.defaultProps = {
  project: {}
};

ViewVideoProject.propTypes = {
  project: PropTypes.object,
  history: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  match: PropTypes.object.isRequired
};

export default withTracker(({ match }) => {
  const projectId = match.params.project_id;
  const subscription = Meteor.subscribe('projects.view', projectId);

  return {
    loading: !subscription.ready(),
    project: Projects.findOne(projectId)
  };
})(ViewVideoProject);
